export default {
	CHROME: 'Chrome',
	FIREFOX: 'Firefox',
	SAFARI: 'Safari',
	EDGE: 'Edge'
};
